// Generated types for ControlPort
// This file is auto-generated - do not edit manually

import { z } from 'zod';

import { DataKind, SignalType } from '../enums';

import { PortReadAPI, PortWriteAPI } from './port';
import { PortReadAPISchemaObject, PortWriteAPISchemaObject } from './port';

// ============================================================================
// TypeScript Interfaces
// ============================================================================

export interface ControlPortReadAPI extends PortReadAPI {
  /** COMMAND | FEEDBACK | MEASUREMENT | STATUS | EVENT | SYNCHRONIZATION. */
  signal_type?: SignalType;
  /** Structured primitive kind (BOOL / INT / FLOAT / ENUM_REF / STRUCT_REF / BLOB). */
  data_kind?: DataKind;
  /** Optional detail for compound kinds: the enum name when kind=ENUM_REF (e.g. 'RobotMode'), or the struct definition when kind=STRUCT_REF (e.g. '{x:f32,y:f32,z:f32}'). Unused for scalar kinds. */
  data_type_spec?: string | null;
  /** Sampling / update rate for periodic signals. */
  sample_rate_hz?: number | null;
}

export interface ControlPortWriteAPI extends PortWriteAPI {
  /** COMMAND | FEEDBACK | MEASUREMENT | STATUS | EVENT | SYNCHRONIZATION. */
  signal_type?: SignalType;
  /** Structured primitive kind (BOOL / INT / FLOAT / ENUM_REF / STRUCT_REF / BLOB). */
  data_kind?: DataKind;
  /** Optional detail for compound kinds: the enum name when kind=ENUM_REF (e.g. 'RobotMode'), or the struct definition when kind=STRUCT_REF (e.g. '{x:f32,y:f32,z:f32}'). Unused for scalar kinds. */
  data_type_spec?: string | null;
  /** Sampling / update rate for periodic signals. */
  sample_rate_hz?: number | null;
  /** The LogicalPart that owns this ControlPort. */
  owner?: string;
  /** Ancestor LPs that surface this port (composite parents in the parent chain). */
  bound_to?: string[];
}

// ============================================================================
// Zod Schemas
// ============================================================================

export const ControlPortReadAPISchema: z.ZodType<ControlPortReadAPI> = PortReadAPISchemaObject.extend({
  signal_type: z.nativeEnum(SignalType).optional(),
  data_kind: z.nativeEnum(DataKind).optional(),
  data_type_spec: z.string().nullable().optional(),
  sample_rate_hz: z.number().nullable().optional(),
}).passthrough();

export const ControlPortWriteAPISchema: z.ZodType<ControlPortWriteAPI> = PortWriteAPISchemaObject.extend({
  signal_type: z.nativeEnum(SignalType).optional(),
  data_kind: z.nativeEnum(DataKind).optional(),
  data_type_spec: z.string().nullable().optional(),
  sample_rate_hz: z.number().nullable().optional(),
  owner: z.string().optional(),
  bound_to: z.array(z.string()).optional(),
}).passthrough();
